<template>
	<div class="facebook-details">
		<el-col class="date-control card-limit">
			<date-control
				platForm="backend"
				moduletitle="Facebook Ads广告报告/受众报告"
				:serviceId="serviceId"
				:websiteList="websiteList"
				:avatarUrl="avatarUrl"
				:pickerType="pickerType"
				:selecttimetype="selecttimetype"
				:format="format"
				:startDate="startDate"
				:endDate="endDate"
				@changeSite="changeSite"
				@change="change"
				@dataChange="dataChange"
			></date-control>
		</el-col>
		<el-col class="card-limit" v-loading="loading_audience">
			<fb-gender-series :condition="condition_gender"></fb-gender-series>
		</el-col>
		<el-col class="card-limit" v-loading="loading_audience" style="margin-right: 1.2%; width: 35%">
			<fb-gender-pie :condition="condition_pie"></fb-gender-pie>
		</el-col>
		<el-col class="card-limit" v-loading="loading_audience" style="width: 63.8%">
			<fb-age-series :condition="condition_age"></fb-age-series>
		</el-col>

		<el-col class="card-limit" v-loading="loading_audience">
			<fb-contry-map :condition="condition_map"></fb-contry-map>
		</el-col>

		<el-col class="contry-list">
			<client-module moduletitle="国家/地区数据详情">
				<el-button type="primary" slot="event" :loading="downloading" size="mini" @click="download"
					>下载</el-button
				>
				<div class="list-content">
					<data-list
						:table-style="{ name: 'webclient' }"
						:data="data"
						:columns="columns"
						:loading="loading"
						:page="page"
						:page-size="page.pageSize"
						@page-size-changed="pageSizeChanged"
						@page-changed="pageChanged"
						@sort-change="sortChange"
					></data-list>
				</div>
			</client-module>
		</el-col>
	</div>
</template>

<script>
import dateControl from '@/components/report/report-date-control.vue';
import createDateControl from '@/components/report/createDateControl.js';
import fbGenderSeries from '@/components/client/clientCharts/fb-gender-series.vue';
import fbGenderPie from '@/components/client/clientCharts/fb-gender-pie.vue';
import fbAgeSeries from '@/components/client/clientCharts/fb-age-series.vue';
import fbContryMap from '@/components/client/clientCharts/fb-contry-map.vue';
import clientModule from '@/components/client/clientModule/clientModule';
import listPageCreate from '@/mixins/listPageCreate';
import fbSer from '@/backend/services/facebook/fbSer.js';
import api from '@/backend/apiConfig/apiConfig';
import filters from '@/mixins/filters.js';
import { download2 } from '@/common/util.js';
import { mapGetters } from 'vuex';

let dateControlMixins = createDateControl();
const list = listPageCreate({
	searchConfig: {
		api: api.fbReport.audienceReportCountry,
		method: 'POST',
	},
	getQuery(data, that) {
		let param = _.assign({}, data, {
			serviceId: that.serviceId,
			type: that.selecttimetype,
			startDate: that.startDate,
			endDate: that.endDate,
			sortDTO: {
				field: data.sortName || 'IMPRESSIONS',
				sort: data.sortType || 'DESC',
			},
		});
		if (data && data.sortName) {
			delete param.sortName;
			delete param.sortType;
		}
		return param;
	},
});
export default {
	mixins: [dateControlMixins, list],
	components: {
		dateControl,
		fbGenderSeries,
		fbGenderPie,
		fbAgeSeries,
		fbContryMap,
		clientModule,
	},
	computed: {
		...mapGetters(['customerId']),
	},
	data() {
		return {
			loading: false,
			downloading: false,
			loading_audience: false,
			condition_gender: {},
			condition_age: [],
			condition_pie: [],
			condition_map: {},
			columns: [
				{
					label: '国家/地区',
					bind: 'countryRegionCn',
				},
				{
					label: '展示次数',
					bind: row => filters.filters.thousands(row['impressions']),
					sort: 'IMPRESSIONS',
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '展示占比',
					bind: row => filters.filters.jojint(row['impressionsPercentage']),
				},
				{
					label: '覆盖人数',
					bind: row => filters.filters.thousands(row['covers']),
					sort: 'COVERS',
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '覆盖占比',
					bind: row => filters.filters.jojint(row['coversPercentage']),
				},
				{
					label: '消耗',
					bind: row => filters.filters.rmb(row['exchangeRateCost']),
					sort: 'COST',
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '消耗占比',
					bind: row => filters.filters.jojint(row['exchangeRateCostPercentage']),
				},
			],
		};
	},
	watch: {
		customerId: {
			async handler(val) {
				if (val) {
					this.disabled = false;
					this.getWebsite(val);
				} else {
					this.disabled = true;
					this.$message.warning('您需要先选择一个客户');
					this.$showCustomerDialog();
				}
			},
			immediate: true,
		},
	},
	methods: {
		getChartDataAll() {
			this.getAudienceReport();
			this.query();
		},
		setCondition() {},
		setConditionPie() {},
		// 受众报告
		async getAudienceReport() {
			const reset = () => {
				this.condition_gender = null;
				this.condition_age = null;
				this.condition_pie = null;
				this.condition_map = null;
			};
			this.loading_audience = true;
			let { startDate, endDate, selecttimetype, serviceId } = this;
			let param = {
				serviceId,
				startDate,
				endDate,
				type: selecttimetype,
				sortDTO: {
					field: 'IMPRESSIONS',
					sort: 'DESC',
				},
			};
			try {
				let res = await fbSer.audienceReport(param);
				if (res && res.data) {
					this.condition_gender = res.data.genderAge;
					this.condition_age = res.data.genderAge.ageList;
					this.condition_pie = res.data.genderAge.genderList;
					this.condition_map = res.data;
				} else {
					reset();
				}
				this.loading_audience = false;
			} catch (e) {
				this.loading_audience = false;
				reset();
				console.error(e);
			}
		},
		async getWebsite(id) {
			const reset = () => {
				this.avatarUrl = '';
				this.websiteList = [];
				this.serviceId = '';
			};
			let res = await fbSer.pageList({
				customerId: id,
			});
			if (res && res.data && res.data.length) {
				this.websiteList = res.data;
				this.avatarUrl = res.data[0].pageAvatar;
				this.serviceId = res.data[0].serviceId;
				this.getWeek();
			} else {
				reset();
			}
		},
		async download() {
			let { startDate, endDate, selecttimetype, serviceId } = this;
			let param = {
				serviceId,
				startDate,
				endDate,
				type: selecttimetype,
				sortDTO: {
					field: 'IMPRESSIONS',
					sort: 'DESC',
				},
			};
			this.downloading = true;
			try {
				let res = await fbSer.audienceReportExport(param);
				this.downloading = false;
				download2(res.data, `受众报告【${this.startDate}至${this.endDate}】.xlsx`);
			} catch (e) {
				this.downloading = false;
				console.error(e);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.facebook-details {
	overflow: hidden;
}
.card-limit {
	margin-bottom: 20px;
}
.contry-list {
	background-color: #fff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	.list-content {
		padding: 20px;
	}
}
</style>
